import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const celiac: AnswerPathTreeNode = {
  path: 'celiac',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCeliacDiseaseDetails }],
};
